import { formatDateLunaire, formatDateWithOrigin } from '@/services/dateFormatter';
import { VaccinationFolder } from '@/store/folder/types';
import { DossierRechercheType } from	'@/store/folder/SearchResult';

import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component
class DisplayPatient extends Vue {
	isNirUrgence(nir: string) {
		return nir.substring(0, 2) === '99';
	}
	dateNaissance(patient: VaccinationFolder | DossierRechercheType) {
		return this.formatDate(_.get(patient, 'dateNaissanceBeneficiaire'));
	}

	formatDate(date: string, format = 'YYYYMMDD'): string {
		if (_.size(date) === 8) {
			return formatDateLunaire(date);
		} else {
			return formatDateWithOrigin(date, format);
		}
	}

	getDefault(value: string | undefined, defaultValue: string | undefined) {
		return !_.isEmpty(value) ? value : defaultValue;
	}

	hasNirBeneficiaire(patient: VaccinationFolder | DossierRechercheType) {
		return !_.isEmpty(_.get(patient, 'nirBeneficiaire'));
	}

	nomFamilleAffichage(patient: VaccinationFolder | DossierRechercheType) {
		if (this.hasNomBeneficiaire(patient)) {
			return this.getDefault(
				_.get(patient, 'nomBeneficiaire'),
				_.get(patient, 'nomPatronymiqueBeneficiaire')
			);
		} else {
			return this.getDefault(
				_.get(patient, 'nomAssure'),
				_.get(patient, 'nomPatronymiqueAssure')
			);
		}
	}

	hasNomBeneficiaire(patient: VaccinationFolder | DossierRechercheType) {
		const defaultNom = this.getDefault(
			_.get(patient, 'nomBeneficiaire'),
			_.get(patient, 'nomPatronymiqueBeneficiaire')
		);
		return !_.isEmpty(defaultNom);
	}

	nomUsageDifferentFamille(patient: VaccinationFolder | DossierRechercheType): boolean {
		return this.nomFamilleAffichage(patient) !== this.nomPatronymiqueAffichage(patient)
			&& !_.isEmpty(this.nomFamilleAffichage(patient));
	}

	nomPatronymiqueAffichage(patient: VaccinationFolder | DossierRechercheType) {
		return this.hasNomBeneficiaire(patient) ?
			_.get(patient, 'nomPatronymiqueBeneficiaire') :
			_.get(patient, 'nomPatronymiqueAssure');
	}

	prenomAffichage(patient: VaccinationFolder | DossierRechercheType) {
		return this.hasNomBeneficiaire(patient) ?
			_.get(patient, 'prenomBeneficiaire') :
			_.get(patient, 'prenomAssure');
	}

	isFeminin(patient: VaccinationFolder | DossierRechercheType): boolean {
		return _.get(patient, 'sexeBeneficiaire') === '2';
	}

	nir(patient: VaccinationFolder | DossierRechercheType) {
		const nir = !_.isEmpty(_.get(patient, 'nirBeneficiaire')) ?
			_.get(patient, 'nirBeneficiaire') :
			_.get(patient, 'nirAssure');
		return _.isNil(nir) || this.isNirUrgence(nir) ? '' : nir;
	}
	nomWithNeAffichage(dossier: DossierRechercheType): string | undefined {
		const nom = this.nomFamilleAffichage(dossier)?.toUpperCase();
		if (this.nomUsageDifferentFamille(dossier)) {
			const ne = this.isFeminin(dossier) ? ', née ' : ', né ';
			return nom + ne + this.nomPatronymiqueAffichage(dossier).toUpperCase();
		} else {
			return nom;
		}
	}
}

export default DisplayPatient;
